<template>
  <DeepError
    :headline="t('error.403.title')"
    :text="t('error.403.text')"
    :title="'403'"
  ></DeepError>
</template>

<script setup lang="ts">
import { DeepError } from '@deepcloud/deep-ui-lib'

const { t } = useI18n()

definePage({
  name: '403',
  meta: {
    breadcrumbLabelKey: 'error.403.title',
  },
})
</script>
